import { SvgIcon, SvgIconProps } from '@components/shared/SvgIcon'

export function LogoutLightIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={'none'}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        id="Stroke 1"
        d="M15.0155 7.39144V6.45844C15.0155 4.42344 13.3655 2.77344 11.3305 2.77344H6.45548C4.42148 2.77344 2.77148 4.42344 2.77148 6.45844V17.5884C2.77148 19.6234 4.42148 21.2734 6.45548 21.2734H11.3405C13.3695 21.2734 15.0155 19.6284 15.0155 17.5994V16.6564"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Stroke 3"
        d="M21.8086 12.0234H9.76758"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Stroke 5"
        d="M18.8809 9.10938L21.8089 12.0244L18.8809 14.9404"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
